/**
 * React dangerouslySetInnerHTML function
 * @see https://reactjs.org/docs/dom-elements.html#dangerouslysetinnerhtml
 * @param {string} m
 * @returns {{__html: *}}
 */
const createMarkup = m => ({ __html: m });

export default createMarkup;
